import { Gigya } from './lib/gigya.js'

export * from './lib/gigya.js'
export default Gigya
